define([
	"dojo/_base/declare",
	"csi/table/AggregateFrom",
	"csi/xml/Query",
	"Specification/BOM/BOMSectionMixin",
	"Specification/BOM/PartMaterialBOMSectionMixin"
], function(declare,AggregateFrom,Query,BOMSectionMixin,PartMaterialBOMSectionMixin) {

	return declare([AggregateFrom, BOMSectionMixin, PartMaterialBOMSectionMixin], {
		_getActionViewParameters: function(/*Context*/ctx, /*Heading*/h, /*Renderer?*/ren) {
			// summary: filter Materials view by BOMSection rules
			var p = this.inherited(arguments);

			var q = p.m_fixedQuery;
			var qr = this.widget.getQueryResultByDomNode(this.refNode);
			this.applyBomSectionQuery(qr.parentResult.groupValue, q, this.m_cache, false);

			return p;
		}
	});
	
});